<template>
  <load-content :loading="isReady === false || isBusy">
    <div class="container" v-if="tabs_categories.length > 0">
      <div class="header">
        <info-tip 
          :tip="addTagTip"
          :show-icon="false"
          class="pull-right"
        >
          <button 
            class="btn btn-carma btn-square pull-right" 
            :class="{disabled: !showAddTagButton}" 
            @click="addRow"
          >
            <i class="fas fa-plus"></i>
            {{ this.$i18n.t('tag.form.create.title',{resource: ''}) }}
          </button>
        </info-tip>
      </div>
      <div
        v-if="tabs_categories.length"
        class="card clearfix"
      >
      <div class="d-flex filter-categories-container">
        <div class="filter-categories">
          <span>{{$t("tag.form.filters.tag_by_category")}}</span>
          <InputSelect
            v-model="currentTab"
            :options="categoriesOptions"
            :show-labels="false"
            :allow-empty="false"
            :searchable="true"
            open-direction="bottom"
            option-value="id"
            option-label="name"
          />
        </div>
        <div v-if="currentChildTab && isUseOrgWithCategory" class="filter-categories">
          <span>{{$t("tag.form.filters.tag_by_sub_category")}}</span>
          <InputSelect
            v-model="currentChildTab"
            :options="organizationsCategoryOptions"
            :show-labels="false"
            :allow-empty="false"
            :searchable="true"
            open-direction="bottom"
            option-value="id"
            option-label="name"
          />
        </div>
        <div v-if="isUseOrgWithCategory" class="filter-search">
          <div class="search-wrapper">
            <InputText 
              type="search" 
              id="main-search" 
              class="input-ui border search-input"
              :placeholder="$t('search')+'...'"
              :onChange="(val) => onSearchChange(val)"
            />
            <span class="fa fa-search"></span>
          </div>
        </div>
      </div>
        
        <div class="content" v-for="(tab, tabIndex) in tabs_categories" :key="tab.value">
          <load-content :loading="loading === false">
          <div v-if="currentTab === tab.value && tab.value" class="container-tags">
            <div v-if="(currentCategory.category_type_id >= CATEGORY_TYPES.ARTICLE_FEATURE && currentCategory.category_type_id <= CATEGORY_TYPES.ORGANIZATION) || currentCategory.category_type_id == CATEGORY_TYPES.MEDIA_TAG">
              <datatable
                ref="table"
                :key="`table_data_${keyTableData}`"
                v-if="datatable.body"
                :data="datatable"
                @create="addRow(tabIndex)"
                :parameters="{indexArrayCategory: tabIndex}"
                :updatingRow="updatingRowId"
                :loading="projectCategorySetupIsLoading && pagination.tags.page === 1"
              />
              <div class="loading-next-page" v-if="projectCategorySetupIsLoading && pagination.tags.page > 1"><loader /></div>
              <side-panel v-if="showDeleteTag == true" :onClose="closeSidePanel">
                <template>
                    <confirm-delete
                      :label="deleteTagObj.name"
                      :onDelete="() => deleteRow(deleteTagObj)"
                    />
                </template>
              </side-panel>
            </div>
            <div v-if="currentCategory.category_type_id === CATEGORY_TYPES.SOURCE">
              <datatable
                :key="counter"
                v-bind:data="datatableSource"
                @create="addRow(tabIndex)"
                @delete="deleteRow"
                :parameters="{indexArrayCategory: tabIndex}"
                :updatingRow="updatingRowId"
              />
            </div>
            <div v-if="currentCategory.category_type_id === CATEGORY_TYPES.GROUPING">
              <datatable
                v-bind:data="datatableGroup"
                @create="addRow(tabIndex)"
                @delete="deleteRow"
                :parameters="{indexArrayCategory: tabIndex}"
                :updatingRow="updatingRowId"
              />
              <side-panel v-if="showDeleteTag == true" :onClose="closeSidePanel">
                <template>
                  <confirm-delete
                      :label="deleteTagObj.name"
                      :onDelete="() => deleteRow(deleteTagObj)"
                  />
                </template>
              </side-panel>
            </div>
          </div>
          </load-content>
        </div>
        <div>
          <side-panel v-if="showMoreInformation == true" :onClose="closeSidePanel">
              <h3>Edit source</h3>
              <div class="summary">
                <form class="form-side-panel">
                  <div class="form__group field">
                    <input
                      type="input"
                      class="form__field"
                      placeholder="First Name"
                      name="first_name"
                      id="first_name"
                      v-model="sourceEdit.first_name"
                    />
                    <label for="first_name" class="form__label">First Name</label>
                  </div>
                  <div class="form__group field">
                    <input
                      type="input"
                      class="form__field"
                      placeholder="Middle Name"
                      name="middle_name"
                      id="middle_name"
                      v-model="sourceEdit.middle_name"
                    />
                    <label for="middle_name" class="form__label">Middle Name</label>
                  </div>
                  <div class="form__group field">
                    <input
                      type="input"
                      class="form__field"
                      placeholder="Last Name"
                      name="last_name"
                      id="last_name"
                      v-model="sourceEdit.last_name"
                    />
                    <label for="last_name" class="form__label">Last Name</label>
                  </div>
                  <div class="form__group field">
                    <input
                      type="input"
                      class="form__field"
                      placeholder="Title"
                      name="title"
                      id="title"
                      v-model="sourceEdit.title"
                    />
                    <label for="title" class="form__label">Title</label>
                  </div>
                  <div class="form__group field">
                    <input
                      type="input"
                      class="form__field"
                      placeholder="Job Title"
                      name="job_title"
                      id="job_title"
                      v-model="sourceEdit.job_title"
                    />
                    <label for="job_title" class="form__label">Job Title</label>
                  </div>
                  <div class="form__group field">
                    <input
                      type="input"
                      class="form__field"
                      placeholder="Display Name"
                      name="display_name"
                      id="display_name"
                      v-model="sourceEdit.display_name"
                    />
                    <label for="display_name" class="form__label">Display Name</label>
                  </div>

                  <div class="form__group field">
                    <input-select
                      name="affiliation_id"
                      ref="affiliation_id"
                      :options="affiliationOptions"
                      :selectedValue="sourceEdit.affiliation_id"
                      :onChange="(value) => onChangeSource(value, 'affiliation_id')"
                      classNames="source-affiliation-select"
                    />
                  </div>

                  <div class="form__group field">
                    <input type="button" value="Save" class="btn btn-carma" @click="onSendSource" />
                  </div>
                </form>
              </div>
          </side-panel>

          <side-panel v-if="showRemoveSourcePanel" :onClose="closeSidePanel">
            <template>
              <load-content :loading="isBusy">
                <confirm-delete
                  :label="sourceEdit.first_name + (sourceEdit.last_name ? ' ' + sourceEdit.last_name : '')"
                  :title="'messages.confirm_delete.title_remove'"
                  :message="'messages.confirm_delete.message_remove'"
                  :deleteButtonLabel="'remove'"
                  :onDelete="() => onConfirmRemove(sourceEdit)"
                />
              </load-content>
            </template>
          </side-panel>
        </div>
      </div>
    </div>
    <div class="card" v-else>
      <h3>Tags by Categories</h3>
      <div>There are no categories or tags.</div>
      <div class="mt20"></div>
    </div>

    <div v-if="selectedRows.length > 0" class="datatable-bulk-actions">
      <span>{{selectedLabel}} Selected</span>
      <div class="actions">
        <div class="action btn-primary" @click="onBulk('delete')">Delete</div>
      </div>
    </div>

    <side-panel v-if="bulkDeleteOpen" :onClose="closeSidePanel">
      <template>
        <load-content :loading="isBusy">
          <confirm-delete
            :label="selectedLabel"
            :bulk="true"
            :onDelete="onBulkDelete"
          />
        </load-content>
      </template>
    </side-panel>

    <side-panel 
      v-if="showTagForm" 
      :onClose="closeSidePanel"
    > 
      <formTag
        :key="`form_tag_${keyTableData}`"
        :loading="isRunningAddTag"
        :errors="FormTagErrors"
        :categoryType="currentCategory.category_type_id"
        :start-category-id="currentTab"
        :project-id="projectUid"
        :tag-to-edit="tagToEdit"
        @addTag="addTag"
      />
    </side-panel>

    <side-panel v-if="showEditTagSource" :onClose="closeSidePanel">
      <load-content :loading="isBusy">
        <form-renderer
          id="edit-source-form"
          title="tag.form.edit_source.title"
          :fields="['first_name', 'middle_name', 'last_name', 'title', 'job_title', 'display_name', 'affiliation_id']"
          :fieldsAdditions="{affiliation_id: {options: affiliationOptions, selectedValue: selectedAffiliation, searchable: true}}"
          :model="sourceEdit"
          formGroupClass="form-group-full"
          @onSave="onSendSource"
        />
      </load-content>
    </side-panel>
  </load-content>
</template>

<script>
import Vue from 'vue';
import _ from "lodash";
import { mapState, mapActions, mapGetters } from "vuex";
import DataTable from "../datatable";
import { FIELD_TYPE, CATEGORY_TYPES } from "../../config/const";
import { propsForMixin } from "../../helpers/application";
import runShortcut from "../../mixins/shortcuts"
import InputSelect from "../form-components/input-select";
import LoadContent from "../load-content";
import SidePanel from "../side-panel";
import ConfirmDelete from "../confirm-delete";
import { inputErrors } from "../../helpers/inputErrorHelper";
import FormTag from "./form-tag";
import FormRenderer from "../form-renderer";
import InfoTip from "../info-tip";
import Loader from "../loader";
import InputText from '../form-components/input-text';
import FormHelper from '@/helpers/form';

export default {
  name: "Tags",
  components: {
    datatable: DataTable,
    SidePanel,
    ConfirmDelete,
    InputSelect,
    LoadContent,
    FormRenderer,
    FormTag,
    InfoTip,
    Loader,
    InputText
  },
  computed: {
    ...mapGetters('projectSetup', {
      'categories': 'CATEGORIES',
      'categories_can_add_tags': 'CATEGORIES_CAN_ADD_TAGS'
    }),
    ...mapState({
      projectSetup: state => state.projectSetup.projectSetup.data,
      sources: state => state.projectSetup.projectSetup.data.sources || [],
      projectCategorySetup: state => state.projectSetup.projectCategorySetup || [],
      projectCategorySetupIsLoading: state => state.projectSetup?.projectCategorySetup?.isBusy,
      affiliationOptions: state => !_.isEmpty(_.get(state.projectSetup.projectSetup.data, 'affiliations')) && state.projectSetup.projectSetup.data.affiliations.map(a => ({ value: a.id, label: a.name })) || [],
      isBusy: state => state.projectSetup.projectSetup.isBusy,
      loading: state => state.projectSetup.projectSetup.isReady,
      projectSetupGeneral: state => state?.projectSetup?.projectSetup?.data?.general,
    }),
    addTagTip() {
      if (!this.showAddTagButton) return;

      return this.shortcutKeyCodeLabel;
    },
    selectedAffiliation(){
      const aff = this.affiliationOptions.find(a => a.value === this.sourceEdit.affiliation_id);
      return aff && aff.value;
    },
    currentCategory() {
      return this.categories.find(category => {
        return category.id === this.currentTab;
      }) || {}
    },
    tabs_categories: function() {
      let tabsCategories = this.categories.map(function(item) {
        return { title: item.name, value: item.id };
      });

      return tabsCategories;
    },
    categoryTypeId() {
      if (!this.currentCategory) return undefined;

      return this.currentCategory.category_type_id;
    },
    isMediaTag() {
      return this.categoryTypeId === CATEGORY_TYPES.MEDIA_TAG
    },
    showAddTagButton() {
      let show = false;
      if (this.currentCategory) {
        show = this.categories_can_add_tags.indexOf(this.currentCategory) > -1;
      }
      return show;
    },
    selectedLabel() {
      return `${this.selectedRows.length} ${
        this.selectedRows.length == 1 ? "Tag" : "Tags"
      }`;
    },
    isUseOrgWithCategory() { return this.projectSetup?.general?.organizations_with_category },
    organizationCategoryId() { return this.projectSetup?.general?.organizations_category_id },
    isMmiProject() { return this.isUseOrgWithCategory && this.currentCategory?.name?.toLocaleLowerCase() === this.weightOfCoverageName; },
  },
  watch: {
    projectSetup: {
      handler(/*value*/) {}
    },
    isBusy: {
      handler(value){
        if (!this.isReady) {
          this.isReady = !value;
        }
        if (value === false) {
          this.counter++;
          this.updatingRowId = null;
        }
      }
    },
    "pagination.tags": {
      handler(value){
        const { pagination, projectUid, currentTab, currentChildTab, reset_state_tags, searchText} = this;
        
        const filters = {cat_id: currentTab, tag_name: searchText}
        if(currentChildTab){
          filters.parent_tag_id = currentChildTab;
        }
        // sending the isMMI flag to the API if its a MMI project & woc category
        if(this.isMmiProject) pagination.tags.isMMI = this.isMmiProject;

        if(!this.isBusy) this.getProjectCategoriesSetup({projectUid: projectUid, pagination: pagination.tags, filters, reset_state_tags});
        this.reset_state_tags = false;
      },
      deep:true
    },
    "pagination.groupings": {
      handler(value){
        const {datatableGroup, pagination, projectUid, currentTab} = this;
        const {order: tableOrder} = datatableGroup;
        const {order, sort} = value;
        
        tableOrder["column"] = order;
        tableOrder["direction"] = sort;
        this.datatableGroup = Object.assign({}, datatableGroup, { order: tableOrder });
        this.getGroupingSet();
      },
      deep:true
    },
    "pagination.sources": {
      handler(value){
        const {datatableSource, pagination, projectUid, currentTab} = this;
        const {order: tableOrder} = datatableSource;
        const {order, sort} = value;
        
        tableOrder["column"] = order;
        tableOrder["direction"] = sort;
        this.datatableSource = Object.assign({}, datatableSource, { order: tableOrder });
        this.getCategorySources({projectUid, categoryId: currentTab, pagination: pagination.sources});
      },
      deep:true
    },
    categories: {
      handler(value) {
        if (this.currentTab !== undefined) {
          let [category] = value.filter(
            cat => cat.id == this.currentTab
          );
        }
      },
      deep: true
    },
    formErrors: {
      handler(value){
          value && import('vue').then(v => {
            v.default.notify({
              group: "store_notifications",
              type: "error",
              text: value
            })
          });
      },
      deep: true
    },
    currentCategory: {
      handler(value){        
        const self = this;
        const tagsWithPrivateNaming = value ? value.tags.map((tag ) => ({
          ...tag, 
          name: tag.is_private ? `${this.$i18n.t('tag.labels.privateTag')} : ${tag.name}` : tag.name
        })) : [];
        if (value) {
          const categoryColumn = {
            key: "category_type_id",
            label: "Category",
            tooltip: this.$t("tag.list.category.change_to_same_type"),
            orderable: !this.isMmiProject,
            render: (row) => {
              const categories = this.categories.filter(c => (c.category_type_id === value.category_type_id && !c.scoring_default && !c.include_in_score) || c.id === value.id);
              const disabled = value.category_type_id === CATEGORY_TYPES.ORGANIZATION || value.scoring_default || value.include_in_score || categories.length < 2 || this.organizationCategoryId === value?.id || this.isMmiProject;
              return (
                <InputSelect
                  disabled={disabled}
                  name={"row_" + row.id + "_" + row.category_id}
                  selectedValue={row.cat_id}
                  options={categories}
                  allowEmpty={false}
                  placeholder={"Select a category"}
                  option-value="id"
                  option-label="name"
                  onChange={(value) => self.callUpdateTagCategory(value, row) }
                />
              )
            },
          }

          switch (value.category_type_id) {
            case CATEGORY_TYPES.GROUPING:
              this.datatableGroup = {
                columns: [
                  {
                    key: "name",
                    label: "Name",
                    orderable: true,
                    input: {
                      name: "name",
                      type: FIELD_TYPE.INPUT,
                      styleNames: { color: "#ec9148", border: "none" },
                      classNames: "input-name",
                      placeholder: "tag name",
                      onBlur: function(value, key, row) {
                        self.updateGroupingRow(value, key, row);
                      },
                      readOnly: typeof value.scoring_default === 'boolean' && value.scoring_default === true
                    },
                  },
                  categoryColumn
                ],
                body: value.tags,
                resizable: true,
                order: {
                  column: self.pagination.groupings.order,
                  direction: self.pagination.groupings.sort,
                  onChange: function(column, direction) {
                    self.sortGroupTable({ order: column, direction: direction });
                    //self.fetch({ order: column, direction: direction });
                  }
                },
                addRow: {
                  enabled: self.showAddTagButton && value && value.tags && value.tags.length > 5,
                  label: this.$i18n.t('tag.form.create.title', {resource: ''}), // 'Add Grouping',
                  onClick: () => self.addRow()
                },
                removeRow: {
                  enabled: true,
                   onClick: (row) => {
                    this.showDeleteTag = true;
                    return {
                      ...this.deleteTagObj = row
                    }
                  }
                },
                bulkActions: {
                  enabled: typeof value.scoring_default === 'boolean' && !value.scoring_default === true,
                  onSelect: function(rows) {
                    self.selectedRows = rows;
                  }
                }
              };

              break;
            case CATEGORY_TYPES.SOURCE:              
              this.datatableSource = {
                columns: [
                  {
                    key: "first_name",
                    label: "First Name",
                    orderable: true,
                    input: {
                      name: "first_name",
                      type: FIELD_TYPE.INPUT,
                      styleNames: { color: "#ec9148", border: "none" },
                      classNames: "input-name",
                      placeholder: "Input",
                      onBlur: function(value, key, row) {
                        self.updateSourceField(value, key, row);
                      }
                    }
                  },
                  {
                    key: "last_name",
                    label: "Last Name",
                    orderable: true,
                    input: {
                      name: "last_name",
                      type: FIELD_TYPE.INPUT,
                      styleNames: { color: "#ec9148", border: "none" },
                      classNames: "input-name",
                      placeholder: "Input",
                      onBlur: function(value, key, row) {
                        self.updateSourceField(value, key, row);
                      }
                    }
                  },
                  {
                    Key: "",
                    label: "",
                    input: {
                      name: "name",
                      type: FIELD_TYPE.BUTTON,
                      label_button: "...",
                      onClick: function(key, row) {
                        self.openSidePanel(row);
                      }
                    }
                  },
                  categoryColumn
                ],
                body: value.tags,
                resizable: true,
                order: {
                  column: self.pagination.sources.order,
                  direction: self.pagination.sources.sort,
                  onChange: function(column, direction) {          
                    self.sortSourceTable({ order: column, direction: direction });
                  }
                },
                addRow: {
                  enabled: self.showAddTagButton && value && value.tags && value.tags.length > 5,
                  label: this.$i18n.t('tag.form.create.title', {resource: ''}), //'Add Tag',
                  onClick: () => self.addRow()
                },
                removeRow: {
                  enabled: true,
                  onClick: function(row) {
                    self.onRemoveSourceRecord(row);
                  }
                },
                bulkActions: {
                  enabled: true,
                  onSelect: function(rows) {
                    self.selectedRows = rows;
                  }
                }
              };

              break;
            default:      
              this.datatable = {
                columns: [
                  {
                    key: "tag_key",
                    label: "Key",
                    input: {
                      name: "tag_key",
                      type: FIELD_TYPE.INPUT,
                      styleNames: {
                        color: "#ec9148",
                        border: "none",
                        outline: "0px",
                        width: "50px"
                      },

                      onBlur: function(value, key, row) {
                        self.updateRow(value, key, row);
                      },
                      readOnly: (typeof value.scoring_default === 'boolean' && value.scoring_default === true) || this.isMmiProject
                    }
                  },
                  {
                    key: "name",
                    label: "Name",
                    orderable: !this.isMmiProject,
                    input: {
                      name: "name",
                      type: FIELD_TYPE.INPUT,
                      styleNames: { color: "#ec9148", border: "none", width: '100%' },
                      classNames: "input-name",
                      placeholder: "tag name",
                      onBlur: function(value, key, row) {
                        self.updateRow(value, key, row);
                      },
                      readOnly: (typeof value.scoring_default === 'boolean' && value.scoring_default === true) || this.isMmiProject
                    },
                    render: this.isMmiProject ? ({ name, value } = {}) => {
                      return (
                        <span v-tooltip={{ content: value }}>
                          {name}
                        </span>
                      );
                    } : undefined
                  },
                  {
                    key: "weight",
                    label: "Weighting",
                    orderable: !this.isMmiProject,
                    input: {
                      name: "weight",
                      type: FIELD_TYPE.INPUT,
                      styleNames: { border: "none", outline: "none" },
                      placeholder: "0",
                      onBlur: function(value, key, row) {
                        self.updateRow(value, key, row);
                      },
                      readOnly: (typeof value.scoring_default === 'boolean' && value.scoring_default === true) || this.isMmiProject
                    }
                  },
                  {
                    key: "custom_color",
                    label: "Color",
                    input: {
                      name: "custom_color",
                      type: FIELD_TYPE.COLOR,
                      swatchSize: "30",
                      triggerStyle: {
                        width: "14px",
                        height: "14px",
                        borderRadius: "3px",
                      },
                      style: { pointerEvents: this.isMmiProject ? "none" : "auto" },
                      colors: "text-advanced",
                      popoverTo: "left",
                      disabled: this.isMmiProject,
                      onChange: function(value, key, row) {
                        if(this.isMmiProject) return;
                        const color = value.hex || value;
                        self.updateRow(color, key, row);
                      }
                    }
                  },
                  {
                    key: "allow_relationship",
                    label: "Allow Relationship",
                    input: {
                      name: "allow_relationship",
                      id: "allow_relationship",
                      type: FIELD_TYPE.CHECKBOX,
                      onChange: function(value, key, row) {
                        self.updateRow(value, key, row);
                      },
                      disabled: (typeof value.scoring_default === 'boolean' && value.scoring_default === true) || this.isMmiProject
                    }
                  },
                ],
                body: tagsWithPrivateNaming,
                resizable: true,
                order: {
                  column: self.pagination.tags.order,
                  direction: self.pagination.tags.sort,
                  onChange: function(column, direction) {          
                    self.sortTable({ order: column, direction: direction });
                  }
                },
                bulkActions: {
                  enabled: (typeof value.scoring_default === 'boolean' && !value.scoring_default === true) && !this.isMmiProject,
                  onSelect: function(rows) {
                    self.selectedRows = rows;
                  }
                },
                addRow: {
                  enabled: (self.showAddTagButton && value && value.tags && value.tags.length > 5) && !this.isMmiProject,
                  label: this.$i18n.t('tag.form.create.title', {resource: ''}), //'Add Tag',
                  onClick: () => self.addRow()
                },
                removeRow: {
                  enabled: (typeof value.scoring_default === 'boolean' && !value.scoring_default === true) && !this.isMmiProject,
                  onClick: (row) => {
                    this.showDeleteTag = true;
                    return {
                      ...this.deleteTagObj = row
                    }
                  }
                }
              };

              if (this.isMediaTag) {
                const outletscolumn = {
                  Key: "outlets",
                  label: "",
                  input: {
                    name: "outlets",
                    type: FIELD_TYPE.BUTTON,
                    label_button: "...",
                    onClick: function(key, row) {
                      self.showEditTag(row);
                    }
                  }
                }

                this.datatable.columns.push(outletscolumn);
              }

              this.datatable.columns.push(categoryColumn);

              break;
          }
        }
      },
      deep: true
    },
    currentTab: {
      handler(value){
       const isOrganizationCategory = this.categories.find(c=> c.id === value && c.category_type_id === CATEGORY_TYPES.ORGANIZATION)
        if(isOrganizationCategory){
          this.currentChildTab = this.organizationsCategoryOptions?.[0]?.id;
        } else {
          this.currentChildTab = null;
        }
        this.reset_state_tags = true;
        this.pagination.tags = {
          ...this.pagination.tags,
          page: 1
        }
      }
    },
    currentChildTab: {
      handler(value){
        if(!value) return;
        this.reset_state_tags = true;
        this.pagination.tags = {
          ...this.pagination.tags,
          page: 1
        }
      }
    }
  },
  created: function(){
    this.CATEGORY_TYPES = CATEGORY_TYPES;
    //window.addEventListener('keyup', this.handleKeyUp);
    //window.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted: async function() {
    const projectUid = this.$route.params.project_uid;
    if(this.isUseOrgWithCategory && !this.isBusy) await this.getProjectCategoriesSetup({ projectUid, pagination: this.pagination.tags });
    
    if(this.tabs_categories.length > 0) {
      this.organizationsCategoryOptions= this.orgCategories();
      this.categoriesOptions = this.categories.filter(c => c?.id !== this.organizationsCategoryId);
      this.currentTab = this.categories[0].id;
      this.currentChildTab = this.organizationsCategoryOptions?.[0]?.id;
    } 
    else {
      this.currentTab = 1
    }
    this.isReady = true
  },
  methods: {
    ...mapActions({
      getprojectSetup: "projectSetup/getprojectSetup",
      getProjectCategoriesSetup: "projectSetup/getProjectCategoriesSetup",
      updateTag: "projectSetup/updateTag",
      updateTagCategory: "projectSetup/updateTagCategory",
      createTag: "projectSetup/createTag",
      deleteTag: "projectSetup/deleteTag",
      getSources: "projectSetup/getSources",
      //addSource: "projectSetup/addSource",
      addSource: "projectSetup/addCategorySource",
      updateSource: "projectSetup/updateCategorySource",
      //updateSource: "projectSetup/updateSource",
      //removeSource: "projectSetup/removeSource",
      removeSource: "projectSetup/removeCategorySource",
      getSourcesAffiliations: "projectSetup/getSourcesAffiliations",
      updateCategoryGrouping: "projectSetup/updateCategoryGrouping",
      createCategoryGrouping: "projectSetup/createCategoryGrouping",
      deleteCategoryGrouping: "projectSetup/deleteCategoryGrouping",
      getGrouping: "projectSetup/getGrouping",
      getCategoryTags: "projectSetup/getCategoryTags",
      getCategorySources: "projectSetup/getCategorySources",
      createOrganization: "projectSetup/createOrganization",
      deleteTagOrganization: "projectSetup/deleteTagOrganization",
      updateTagOrganization: "projectSetup/updateTagOrganization",
      deleteBulkTags:"projectSetup/deleteBulkTagsByCategory",
      deleteBulkGroupingTags:"projectSetup/deleteBulkGroupingsByCategory",
      deleteBulkSourceTags: "projectSetup/deleteBulkSourcesByCategory"
    }),

    scroll: function() {
      const { categories } = this;
      if (categories) {
        const { currentPage, totalPages } = this.projectCategorySetup.pagination;

        if (currentPage < totalPages) {
          const wHeight = window.innerHeight;
          const {
            top,
            bottom,
            height
          } = this.$refs.table?.[0]?.$el?.getBoundingClientRect();
          const margin = 100;

          if (top * -1 + wHeight >= height - margin && this.projectCategorySetupIsLoading === false) {
            const { pagination } = this;
            this.pagination.tags = {
              ...pagination.tags,
              page: pagination.tags.page + 1
            }
          }
        }
      }
    },
    
    handleScroll: function() {
      this.scroll();
    },

    inputErrors,

    callUpdateTagCategory (value, row) {
      this.updateTagCategory({
        newCategoryId: value,
        categoryId: row.cat_id,
        tagId: row.id,
        projectId: this.projectUid
      });
    },

    async fetch() {
      const { projectUid } = this;
      await Promise.all([
        //this.getCategorySources(this.currentTab),
        this.getSourcesAffiliations({ projectUid }),
      ]).then(() => {
        //
      });
    },

    handleClick(newTab) {
      this.currentTab = newTab;
      const [category] = this.categories.filter(
        cat => cat.id == this.currentTab
      );
    },

    openSidePanel: function(row) {
      this.sourceEdit = { ...row };     
      this.fetch();
      // this.showMoreInformation = true;
      this.showEditTagSource = true;
    },

    showEditTag(row) {
      this.tagToEdit = row;
      this.showTagForm = true;
    },

    closeSidePanel: function() {
      this.showMoreInformation = false;
      this.showRemoveSourcePanel = false;
      this.showDeleteTag = false;
      this.showTagForm = false;
      this.showEditTagSource = false;
      this.FormTagErrors = [];
      this.bulkDeleteOpen = false;
      this.isRunningAddTag = false;
    },

    buildRenderOptions: function() {
      return {};
    },

    onBulk: function(action){
      if (action == "delete") {
        this.bulkDeleteOpen = true;
      }
    },

    onBulkDelete: function(){ 
      const {projectUid, currentCategory, selectedRows: bulkTags, closeSidePanel} = this; 

      if (currentCategory.category_type_id === CATEGORY_TYPES.SOURCE) {
        const {deleteBulkSourceTags} = this;
        deleteBulkSourceTags({projectUid, bulkTags}).then(r => {
          closeSidePanel();
          this.selectedRows = [];
        });
      }
      else if (this.currentCategory.category_type_id === CATEGORY_TYPES.GROUPING) {
        const {deleteBulkGroupingTags} = this;
        deleteBulkGroupingTags({projectUid, bulkTags}).then(r => {
          closeSidePanel();
          this.selectedRows = [];
        });
      }
      else {
        const {deleteBulkTags} = this;
        deleteBulkTags({projectUid, bulkTags, categoryId: currentCategory.id}).then(r => {
          closeSidePanel();
          this.selectedRows = [];
        });
      }
    },

    addRow() {
      if (!this.showAddTagButton) return;
      this.fetch();
      this.tagToEdit = null;
      this.showTagForm = true;
    },

    addTag(tag) {
      const row = {
        cat_id: tag.categoryId,
        categoryId: tag.categoryId,
        allow_relationship: tag.allowRelationship,
        custom_color: tag.customColor,
        ...tag
      };

      delete row.allowRelationship;
      delete row.customColor;

      this.currentTab = tag.categoryId;
      const projectUid = this.projectUid;

      this.isRunningAddTag = true;

      if (tag.categoryTypeId === CATEGORY_TYPES.SOURCE) {
        this.FormTagErrors = [];
        this.addSource({ projectUid, source: row }).then(r => {
          if(!_.isEmpty(r.error)) this.FormTagErrors.push(r.error);
          else {
            this.closeSidePanel();
          }
        });
      }
      else if (tag.categoryTypeId === CATEGORY_TYPES.GROUPING) {
        this.FormTagErrors = [];
        this.createCategoryGrouping({ projectUid, row }).then(r => {
          if (!_.isEmpty(r.error)) {
            this.FormTagErrors.push(r.error);
          }else{
            this.closeSidePanel();
          }
        });
      }
      // else if(this.currentCategory.category_type_id === CATEGORY_TYPES.ORGANIZATION){
      //   this.createOrganization({projectUid, row});
      // }
      else {
        this.FormTagErrors = [];

        if (row.id) {
          this.tagToEdit = row;
          this.updateTag({ projectUid, row: { ...row, parent_tag_id: this.currentChildTab } })
          .then(r => {
            if(!_.isEmpty(r.error)) {
              this.FormTagErrors.push(r.error);
            } else {
              this.tagToEdit = r;
              this.keyTableData++;
              this.closeSidePanel();
            }
          })
          .finally(() => {
            this.isRunningAddTag = false;
          });
        } else {
          this.createTag({ projectUid, row }).then(r => {
            this.closeSidePanel();
          })
          .finally(() => {
            this.isRunningAddTag = false;
          });
        }
      }
    },

    deleteRow(row) {
      const projectUid = this.projectUid;
        if(this.currentCategory.category_type_id === CATEGORY_TYPES.GROUPING) {
          this.deleteCategoryGrouping({ projectUid, row: this.deleteTagObj });
          this.showDeleteTag = false;
        } 
        else if(this.currentCategory.category_type_id === CATEGORY_TYPES.ORGANIZATION){
          this.deleteTagOrganization({ projectUid, row: this.deleteTagObj });
          this.showDeleteTag = false; 
        } else {
          this.deleteTag({ projectUid, row: this.deleteTagObj });
          this.showDeleteTag = false;
        }
    },

    deleteGroup(row){
      const projectUid = this.projectUid;
      this.deleteCategoryGrouping({ projectUid, row });
    },

    updateRow(value, key, row) {
      this.formErrors = null;
      if (key === "weight") {
          this.formErrors = this.inputErrors(value, "number_decimal", "Weighting");
      }    
      if (key === "tag_key") {
          this.formErrors = this.inputErrors(value, "number_&_not_null", "Key");
      }  
      if (key === "name") {
          this.formErrors = this.inputErrors(value, "not_null", "Name");
      }
      if (!this.formErrors) {
        let newRow = {
          id: row.id,
          cat_id: row.cat_id,
          [key]: value,
          parent_tag_id: this.currentChildTab
        }
        const projectUid = this.projectUid;
        this.updatingRowId = row.id
        const updatedRowId = (id) => {
          this.updatingRowId = id || null
        }
        this.currentCategory.category_type_id === CATEGORY_TYPES.ORGANIZATION 
          ? this.updateTagOrganization({ projectUid, row: newRow }).then(r => {
                updatedRowId(r?.cat_id);
              }).catch(() => {
                updatedRowId(null);
              })
          : this.updateTag({ projectUid, row: newRow }).then(r => {
                updatedRowId(r?.cat_id);
              }).catch(() => {
                updatedRowId(null);
              })
      }     
    },

    updateGroupingRow(value, key, row) {
      let newRow = _.cloneDeep(row);
      newRow[key] = value;

      const projectUid = this.projectUid;
      newRow = Object.assign({}, newRow);
      this.updateCategoryGrouping({ projectUid, row: newRow });
    },

    updateSourceField(value, key, row) {
      const source = {
        ...row,
        [key]: value
      };

      const { projectUid } = this;
      this.updateSource({ projectUid, source });
    },

    getGroupingSet() {
      const projectUid = this.projectUid;
      const source = {
        cat_id: this.currentTab
      };
            
      return this.getGrouping({ projectUid, source, pagination: this.pagination.groupings });
    },

    onChangeSource(value, field) {
      this.sourceEdit[field] = value;
    },

    onRemoveSourceRecord(row) {
      this.sourceEdit = {
        ...row
      };
      this.showRemoveSourcePanel = true;
    },

    onConfirmRemove(source) {
      const projectUid = this.projectUid;      
      this.removeSource({ projectUid, sourceId: source.id }).then(() => {
        this.closeSidePanel();
      });
    },

    onSendSource(source) {
      const { projectUid } = this;
      this.updateSource({ projectUid, source }).then(r => {
        this.showEditTagSource = false;
      });
    },

    sortTable({order, direction}){     
      this.reset_state_tags = true;
      this.pagination.tags.order = order;
      this.pagination.tags.sort = direction;
      this.pagination.tags.page = 1;
    },
    sortGroupTable({order, direction}){
      this.pagination.groupings.order = order;
      this.pagination.groupings.sort = direction;
    },
    sortSourceTable({order, direction}){
      this.pagination.sources.order = order;
      this.pagination.sources.sort = direction;
    },
    orgCategories() {
      this.organizationsCategoryId = this.projectSetupGeneral?.organizations_category_id;
      // return early if data not proper
      if(!this.projectSetupGeneral?.organizations_with_category || !this.organizationsCategoryId) {
          return [];
      }
      const _cate = (this.projectCategorySetup?.data || [])?.find(c => c?.id === this.organizationsCategoryId);
      if(!_cate) return [];
      // prepare data for tabs component
      this.projectSetupDataTabs = _cate?.tags?.map((c, i) => {
          c.value = c?.id;
          c.title = c?.name;
          c.order = c?.display_order || i+1;
          return c;
      });

      // default to the 1st option/tab
      return this.projectSetupDataTabs;
    },
    onSearchChange(searchText) {
      FormHelper.delayFunction(()=> this.onSearch(searchText), 500, this);
    },
    onSearch (value) {
      this.searchText = value;
      this.globalTimeout = null;
      const { pagination } = this;
      this.pagination.tags = {
        ...pagination.tags,
        page: 1
      }
      this.reset_state_tags = true;
    }
  },

  data: function() {
    const projectUid = this.$route.params.project_uid;
    return {
      isRunningAddTag: false,
      keyTableData: 1,
      counter: 0,
      isReady: false,
      updatingRowId: null,
      datatable: {},
      datatableSource: {},
      datatableGroup: {},
      currentTags: {},
      currentTab: 1,
      tagSource: false,
      tagGroups: false,
      tagOrganization: false,
      showMoreInformation: false,
      showRemoveSourcePanel: false,
      projectUid,
      selectedRows: [],
      bulkDeleteOpen: false,
      sourceEdit: {},
      //source: [],
      formErrors: null,
      FormTagErrors: [],
      categoryId: undefined,
      pagination: {
        tags: {
          page: 1,
          perPage: 50,
          order: "tag_key",
          sort: "asc"
        },
        groupings: {
          page: 1,
          limit: 50,
          order: "name",
          sort: "asc"
        },
        sources: {
          page: 1,
          limit: 50,
          order: "id",
          sort: "asc"
        }
      },
      showDeleteTag: false,
      deleteTagObj: {},
      showTagForm: false,
      tagToEdit: null,
      showEditTagSource: false,
      //keysPressed: []
      reset_state_tags: false,
      organizationsCategoryId: null,
      organizationsCategoryOptions: [],
      categoriesOptions: [],
      currentChildTab: null,
      globalTimeout: null,
      searchText: '',
      weightOfCoverageName: 'weight of coverage'
    };
  },

  mixins: [propsForMixin, runShortcut('addTag')]
};
</script>

<style lang="scss" scoped>

  .filter-categories-container {
    gap: 20px; 

    .filter-categories {
      flex: 1; 
    }

    .filter-search {
      flex-grow: 1; 
      max-width: 320px;
      margin-left: auto;
      padding-top: 10px;

      .search-wrapper {
        position: relative;
      }

      .search-input {
        width: 100%;
        padding-right: 25px;
      }

      .fa-search {
        position: absolute;
        right: 8px;
        top: 25%;
        cursor: pointer;
        color: $gray-400;
      }
    }
  }

  .container-tags {
    width: 100%;
    overflow: visible !important;
    animation: fadeIn 800ms;

    .table-outer {
      overflow: inherit;
    }
  }

  .input-checkbox {
    margin-top: -17px;
  }

  .remove-item {
    color: #ec9148;
    font-size: 0.7rem;
    cursor: pointer;
    margin-left: 4px;
  }

  .tab_slide_content {
    padding-top: 10px;
  }

  .content {
    margin-top: 20px;
  }

  .form-side-panel {
    display: flex;
    flex-direction: column;
  }

  @import "../../styles/components/coding-admin/_tags.scss";
  @import "../../styles/components/_datatable_bulk_actions.scss";

  .filter-categories {
    max-width: 240px;
  }

  .btn.remove-source {
    display: inline-block;
    width: auto;
    margin-top: 20px;
  }
</style>
